import { Super } from './super.model';

export class Licensetype extends Super<Licensetype> {

    public name: string;
    public description: string;
    public days: number;
    public slug: string;

    
}